<template>
  <div class="foot">

      <div class="cp">
    <p><b>&copy; K.W.</b></p>
</div>





  </div>
</template>

<script>
export default {
  name: 'Footern',

  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cp {
    padding-top: 1em;
    padding-bottom: 1em;
    background-color: #2c3e50;
    color: white;
}

.foot {
    margin:0;
}
p {
    margin:0;
}
</style>
